import React from "react";

export default function MailSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="34"
      height="33"
      fill="none"
      viewBox="0 0 34 33"
    >
      <path
        stroke="#1C64F2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
        d="M19.616 3.122l11.292 7.34c.399.26.598.39.743.562a1.5 1.5 0 01.283.521c.066.216.066.454.066.93v10.997c0 2.52 0 3.78-.49 4.743a4.5 4.5 0 01-1.967 1.966c-.963.49-2.223.49-4.743.49H9.2c-2.52 0-3.78 0-4.743-.49a4.5 4.5 0 01-1.967-1.966C2 27.252 2 25.992 2 23.472V12.474c0-.476 0-.713.066-.929.059-.19.155-.368.283-.52.145-.174.344-.303.743-.563l11.292-7.34m5.232 0c-.947-.615-1.42-.923-1.93-1.043a3 3 0 00-1.372 0c-.51.12-.983.428-1.93 1.043m5.232 0l10.836 7.044c.516.335.774.503.863.715a.75.75 0 010 .582c-.09.212-.347.38-.863.715l-10.836 7.044c-.947.615-1.42.923-1.93 1.043a3 3 0 01-1.372 0c-.51-.12-.983-.428-1.93-1.043L3.548 12.178c-.516-.335-.774-.503-.863-.716a.75.75 0 010-.58c.09-.213.347-.38.863-.716l10.836-7.044"
      ></path>
    </svg>
  );
}
